import { render, staticRenderFns } from "./registrationAgreement.vue?vue&type=template&id=28924e26&scoped=true"
var script = {}
import style0 from "./registrationAgreement.vue?vue&type=style&index=0&id=28924e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28924e26",
  null
  
)

export default component.exports